import { render, staticRenderFns } from "./correct4.vue?vue&type=template&id=a83ff086&scoped=true&"
import script from "./correct4.vue?vue&type=script&lang=js&"
export * from "./correct4.vue?vue&type=script&lang=js&"
import style0 from "./correct4.vue?vue&type=style&index=0&id=a83ff086&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83ff086",
  null
  
)

export default component.exports